<template>
  <div class="tabs">
    <div
      class="tab"
      v-for="tab in summary"
      :key="tab.type"
      :class="{ 'active': tab.type === type }"
      @click="tab.type !== type && handleClick(tab.type)"
    >
      <div class="tab-title">
        {{ label(tab.label) }}
      </div>
      <div class="seperator" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    summary: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'all',
    },
  },
  methods: {
    handleClick (type) {
      this.$emit('handleClick', type);
    },
    label (label) {
      return label.toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
  .tabs {
    display: flex;
    align-items: center;
    flex-direction: row;
    border-bottom: 2px solid #f1f2f7;

    .tab {
      position: relative;
      text-align: center;
      padding: 20px;
      margin-bottom: -2px;
      cursor: pointer;

      &:last-child {
        .seperator {
          display: none;
        }
      }

      .seperator {
        height: 30px;
        border-right: 1px solid #dcdee4;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }

      .tab-title {
        font-size: 14px;
        font-weight: 500;
        color: #95a1b5;
      }

      &.active {
        border-bottom: 2px solid #f27a1a;

        .tab-title {
          color: #f27a1a;
        }

        .tab-count {
          color: #273142;
        }
      }

      &:hover {
        .tab-title {
          color: #f27a1a;
        }

        .tab-count {
          color: #273142;
        }
      }
    }
  }
</style>
